import React from "react";

import {
  LegalContainer,
  LegalTitle,
  LegalSectionTitle,
  LegalSectionBlock,
  LegalOrderedList,
  LegalListItem,
} from "@components/Template/Legal.style";
import { getServerSideTranslationsWrapper } from "../../src/nextUtils";

const TermsConditions = () => {
  return (
    <LegalContainer>
      <LegalTitle>
        Terms of Use for the application « Analytics by Deezer »
      </LegalTitle>

      <LegalSectionTitle>Article 1 – General remarks</LegalSectionTitle>
      <LegalSectionBlock>
        The application « Analytics by Deezer » is created, developed and
        operated by DEEZER, a French corporation, registered under number RCS
        511 716 573, with its principal offices located at 12 rue d’Athènes,
        75009 PARIS, FRANCE (« DEEZER »).
      </LegalSectionBlock>
      <LegalSectionBlock>
        These Terms of Use (hereinafter « ToU ») govern the access and use of
        the application developed by DEEZER named « Analytics by Deezer » («
        Analytics by Deezer App »).
      </LegalSectionBlock>
      <LegalSectionTitle>
        Article 2 – The Analytics by Deezer App description
      </LegalSectionTitle>
      <LegalSectionBlock>
        The Analytics by Deezer App was developed by DEEZER to provide its
        releases providers with data and analytics enabling them to measure
        performance and analyse their audience.
      </LegalSectionBlock>
      <LegalSectionTitle>
        Article 3 – Access to the Analytics by Deezer App
      </LegalSectionTitle>
      <LegalSectionBlock>
        Access and use of the Analytics by Deezer App is strictly limited to
        DEEZER’s releases providers or producers and their authorized personnel
        (“App Users”).
      </LegalSectionBlock>
      <LegalSectionBlock>
        In order to access and use the Analytics by Deezer App, every App User
        must abide by the present ToU and must:
      </LegalSectionBlock>
      <LegalOrderedList>
        <LegalListItem>
          Create an account on the Analytics by Deezer App;
        </LegalListItem>
        <LegalListItem>Claim a RSS feed; and</LegalListItem>
        <LegalListItem>
          Enter the verification code sent to the email address in the RSS feed;
        </LegalListItem>
      </LegalOrderedList>
      <LegalSectionTitle>
        Article 4 – Use of the Analytics by Deezer App
      </LegalSectionTitle>
      <LegalSectionBlock>
        The use of the Analytics by Deezer App is strictly limited to DEEZER’s
        releases providers and their authorized personnel. The App User shall
        keep confidential and not communicate, transmit, reproduce, copy,
        publish, broadcast or otherwise disclose any information or data made
        available or accessible via the Analytics by Deezer App.
      </LegalSectionBlock>

      <LegalSectionTitle>
        Article 5 - Availability and modification of the Analytics by Deezer App
      </LegalSectionTitle>

      <LegalSectionBlock>
        The Analytics by Deezer App can be accessed 24 hours a day and seven
        days a week within the limits set out in these ToU.
      </LegalSectionBlock>
      <LegalSectionBlock>
        DEEZER has the right to make any modifications to the Analytics by
        Deezer App as it deems necessary. Furthermore, DEEZER has the right,
        without prior notice or compensation, to temporarily remove access to
        the Analytics by Deezer App in order to ensure the maintenance or
        continuity of the Analytics by Deezer App or otherwise. DEEZER also has
        the right, without compensation, to shut down access permanently to the
        Analytics by Deezer App.
      </LegalSectionBlock>

      <LegalSectionTitle>
        Article 6 – Disclaimer of warranties
      </LegalSectionTitle>
      <LegalSectionBlock>
        EXCEPT AS OTHERWISE PROVIDED IN THESE TOU, TO THE MAXIMUM EXTENT
        PERMITTED BY APPLICABLE LAW, THE ANALYTICS BY DEEZER APP IS PROVIDED “AS
        IS”,“AS AVAILABLE” AND WITHOUT ANY WARRANTY OF ANY KIND, EXPRESS OR
        IMPLIED, INCLUDING BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF TITLE,
        NON INFRINGEMENT, MERCHANTABILITY, QUALITY, AND FITNESS FOR A PARTICULAR
        PURPOSE, AND ANY WARRANTIES IMPLIED BY ANY COURSE OF PERFORMANCE OR
        USAGE OF TRADE, ALL OF WHICH ARE EXPRESSLY DISCLAIMED. DEEZER DOES NOT
        WARRANT THAT (I) THE ANALYTICS BY DEEZER APP WILL BE SECURE OR AVAILABLE
        AT ANY PARTICULAR TIME OR LOCATION, (II) ANY DEFECTS OR ERRORS WILL BE
        CORRECTED, (III) ANY CONTENT OR SOFTWARE AVAILABLE ON OR THROUGH THE
        ANALYTICS BY DEEZER APP IS FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS,
        (IV) THE CONTENT ON THE ANALYTICS BY DEEZER APP IS ACCURATE, ERROR-FREE,
        APPROPRIATE, COMPLIANT, OR COMPLETE, OR (V) THE RESULTS OF USING THE
        ANALYTICS BY DEEZER APP WILL MEET THE APP USER’S REQUIREMENTS.
      </LegalSectionBlock>
      <LegalSectionBlock>
        DEEZER disclaims liability for any dysfunction on the Analytics by
        Deezer App, whether it concerns its access, consultation speed, the
        temporary or definitive inaccessibility of the Analytics by Deezer App,
        and the fraudulent use by third parties of the information provided on
        the Analytics by Deezer App which DEEZER cannot be held responsible for.
      </LegalSectionBlock>
      <LegalSectionBlock>
        Therefore, it is the App User’s duty to protect his/her equipment,
        notably against any form of intrusion and/or virus contamination and for
        which DEEZER can never be held liable. DEEZER can never be held liable
        for any dysfunction or damage caused to the App User’s equipment which
        are not attributable to culpable actions of DEEZER.
      </LegalSectionBlock>
      <LegalSectionBlock>
        Furthermore, DEEZER disclaims any liability if a breach of any of its
        obligations results from acts of nature, forces, or causes beyond its
        reasonable control, including, without limitation, Internet failures,
        computer equipment failures, telecommunication equipment failures, other
        equipment failures, electrical power failures, strikes, labor disputes,
        riots, insurrections, civil disturbances, shortages of labor or
        materials, fires, floods, storms, explosions, acts of God, war,
        governmental actions, orders of domestic or foreign courts or tribunals,
        non-performance of third parties, or loss of or fluctuations in heat,
        light, or air conditioning and more broadly any unstoppable and
        unforeseen event which prevent the good execution of the orders.
      </LegalSectionBlock>
      <LegalSectionBlock>
        DEEZER disclaims liability in the event the Analytics by Deezer App is
        incompatible with certain equipment and/or functionalities of the
        equipment of the App User.
      </LegalSectionBlock>
      <LegalSectionBlock>
        Finally, the App User is liable for his/her use of the Analytics by
        Deezer App and cannot hold DEEZER liable for any claim and/or procedure
        made against him/her in that respect. The App User shall take on every
        claim, complaint or objection and any proceedings filed against DEEZER
        by a third-party in relation to the App User’s culpable violation of
        their obligations in the course of their use of the Analytics by Deezer
        App.
      </LegalSectionBlock>
      <LegalSectionTitle>Article 7 – Intellectual property</LegalSectionTitle>
      <LegalSectionBlock>
        The general structure of the Analytics by Deezer App and all elements
        composing it (such as but not limited to the logos, photos, images,
        texts, or any visuals) are the exclusive property of DEEZER and/or its
        licensors.
      </LegalSectionBlock>
      <LegalSectionBlock>
        These elements are protected by intellectual property laws and others,
        and notably copyright law. The App User can only use these elements for
        the purpose of using the Analytics by Deezer App in compliance with
        these ToU.
      </LegalSectionBlock>
      <LegalSectionBlock>
        Any total or partial representation of the Analytics by Deezer App
        and/or the elements composing them (as described above) by any means
        without the express consent of DEEZER is therefore forbidden and would
        be considered as infringement of law.
      </LegalSectionBlock>
      <LegalSectionTitle>Article 8 – Nullity of an article</LegalSectionTitle>
      <LegalSectionBlock>
        In case one of the provisions of these ToU would be declared void or
        voidable for any reason, the remainder of the ToU will continue to apply
        in full force and effect.
      </LegalSectionBlock>
      <LegalSectionTitle>
        Article 9 – Applicable law and jurisdiction
      </LegalSectionTitle>
      <LegalSectionBlock>
        The present ToU are governed by the laws of France. In case of claims,
        the parties will try to reach an amicable agreement before any judicial
        proceeding. If no amicable agreement can be reached, any claim regarding
        the validity, the interpretation and/or the execution of the ToU shall
        be brought before the courts of the Paris, France.
      </LegalSectionBlock>
    </LegalContainer>
  );
};

export const getStaticProps = getServerSideTranslationsWrapper();

export default TermsConditions;
